import { InjectionToken } from '@angular/core';

/**
 * @description
 * Provide max image size in bytes
 *
 */
export const NewsImgSizeLimitsToken = new InjectionToken<{
  imgMaxSize: number;
}>('News image limits configuration');
